import axios from 'axios';
import { getConfig } from '../../../config/apiConfig';
import getLogger from '../../../utils/logger';

const trackNavigationHistory = async (destinationType, destinationValue, destinationUrl) => {
  const config = await getConfig();
  const requestUrl = `api/core/person/navigationHistory?destinationType=${destinationType}&destinationValue=${destinationValue}&destinationUrl=${destinationUrl}`;
  return axios
    .post(requestUrl, null, config)
    .then(async (response) => {
      return response.data;
    })
    .catch((err) => {
      getLogger().error(err);
      return null;
    });
};

export default trackNavigationHistory;
